import { useNavbar } from "@/hooks/use-navbar";
import { Burger, Button } from "@mantine/core";

export function AppShellToggleButton() {
  const { opened, setNavbar } = useNavbar();

  return (
    <Button
      radius="md"
      size="sm"
      w="fit-content"
      px={12}
      onClick={() => setNavbar(!opened)}
      hiddenFrom="sm"
      component="div"
    >
      <Burger
        color="var(--white)"
        fw={600}
        opened={opened}
        hiddenFrom="sm"
        size="xs"
      />
    </Button>
  );
}

